import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const organizationPropertyValue = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    textValue: z.string().nullable().optional().describe('Text Value'),

    numberValue: z.number().nullable().optional().describe('Number Value'),

    organizationId: z.number().hidden().describe('Foreign key to Organization'),

    organizationPropertyId: z
      .number()
      .presentAs('reference')
      .describe('Foreign key to OrganizationProperty'),

    organization: belongsTo('Organization'),

    organizationProperty: references('OrganizationProperty'),
  })
  .describe(
    "One organization's value for a configurable organization property.",
  )
  .as('OrganizationPropertyValue');

export { organizationPropertyValue as organizationPropertyValueSchema };
